import { useEffect, useState } from "react";
import { api, getToken, setToken, clearToken } from "./lib/api.js";
import Login from "./components/Login.jsx";
import CommandCenter from "./views/CommandCenter.jsx";

export default function App() {
  const [token, setTokenState] = useState(getToken());
  const [screen, setScreen] = useState(token ? "checking" : "login");

  useEffect(() => {
    if (!token || screen !== "checking") return;
    api
      .commandCenter(token)
      .then((res) => {
        // Any error here means the stored token is stale or the user has no
        // tenant. Both cases send them back to login rather than onboarding,
        // which used to swallow real auth failures.
        if (res.error) {
          clearToken();
          setScreen("login");
        } else {
          setScreen("dashboard");
        }
      })
      .catch(() => setScreen("login"));
  }, [token, screen]);

  const handleAuth = (t) => {
    setToken(t);
    setTokenState(t);
    setScreen("dashboard");
  };

  if (screen === "login" || !token) return <Login onAuth={handleAuth} />;

  if (screen === "checking") {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          color: "var(--t3)",
        }}
      >
        Loading…
      </div>
    );
  }

  return <CommandCenter token={token} />;
}
